"use client";

import { Play } from "lucide-react";
import { usePostHog } from "posthog-js/react";
import { useRef, useState } from "react";

export function SchoolFilm() {
  const posthog = usePostHog();
  const videoRef = useRef<HTMLVideoElement>(null);
  const hasTrackedStart = useRef(false);
  const [hasStarted, setHasStarted] = useState(false);

  const handlePlay = () => {
    setHasStarted(true);
    if (hasTrackedStart.current) return;

    hasTrackedStart.current = true;
    posthog?.capture("schools_demo_started", { placement: "course_film" });
  };

  return (
    <div className="relative aspect-video overflow-hidden rounded-[26px] bg-black shadow-2xl shadow-black/20">
      <video
        ref={videoRef}
        src="/ui/french-hybrid-course-launch-16x9.mp4"
        poster="/ui/french-hybrid-course-launch-16x9-poster.jpg"
        controls
        playsInline
        preload="none"
        onPlay={handlePlay}
        className="h-full w-full bg-black object-cover"
        aria-label="ChickyTutor French hybrid course film"
      />
      {!hasStarted && (
        <button
          type="button"
          onClick={() => void videoRef.current?.play()}
          className="absolute inset-0 flex items-center justify-center bg-black/5 transition hover:bg-black/10"
          aria-label="Play the ChickyTutor school partnership film"
        >
          <span className="flex h-20 w-20 items-center justify-center rounded-full bg-[#f26b2d] text-white shadow-2xl transition hover:scale-105 hover:bg-[#c84f1f]">
            <Play className="ml-1 h-8 w-8 fill-current" aria-hidden />
          </span>
        </button>
      )}
    </div>
  );
}
